import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AppShell from "@/components/AppShell";
import { Loading } from "@/components/shared";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import MagicVerify from "@/pages/MagicVerify";
import Dashboard from "@/pages/Dashboard";
import StartHere from "@/pages/StartHere";
import Conclusion from "@/pages/Conclusion";
import Moments from "@/pages/Moments";
import PartSection from "@/pages/PartSection";
import Chapter from "@/pages/Chapter";
import TemplateLibrary from "@/pages/TemplateLibrary";
import TemplateDetail from "@/pages/TemplateDetail";
import BuildSystem from "@/pages/BuildSystem";
import SearchPage from "@/pages/SearchPage";
import Account from "@/pages/Account";
import ChapterEditor from "@/pages/ChapterEditor";
import PageEditor from "@/pages/PageEditor";
import TemplateAdmin from "@/pages/TemplateAdmin";
import AdminCenter from "@/pages/AdminCenter";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Terms from "@/pages/Terms";
import MyTeam from "@/pages/MyTeam";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen bg-nm-bg"><Loading /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function App() {
  return (
    <div className="App font-sans">
      <BrowserRouter>
        <AuthProvider>
          <ThemeProvider>
          <Toaster position="top-center" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/magic" element={<MagicVerify />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Terms />} />
            <Route path="/app" element={<Protected><Dashboard /></Protected>} />
            <Route path="/app/start-here" element={<Protected><StartHere /></Protected>} />
            <Route path="/app/part/:part" element={<Protected><PartSection /></Protected>} />
            <Route path="/app/chapter/:slug" element={<Protected><Chapter /></Protected>} />
            <Route path="/app/admin/chapter/:slug" element={<Protected><ChapterEditor /></Protected>} />
            <Route path="/app/admin/page/:pageKey" element={<Protected><PageEditor /></Protected>} />
            <Route path="/app/admin/templates" element={<Protected><TemplateAdmin /></Protected>} />
            <Route path="/app/admin/center" element={<Protected><AdminCenter /></Protected>} />
            <Route path="/app/templates" element={<Protected><TemplateLibrary /></Protected>} />
            <Route path="/app/template/:slug" element={<Protected><TemplateDetail /></Protected>} />
            <Route path="/app/build-system" element={<Protected><BuildSystem /></Protected>} />
            <Route path="/app/conclusion" element={<Protected><Conclusion /></Protected>} />
            <Route path="/app/moments" element={<Protected><Moments /></Protected>} />
            <Route path="/app/search" element={<Protected><SearchPage /></Protected>} />
            <Route path="/app/account" element={<Protected><Account /></Protected>} />
            <Route path="/app/team" element={<Protected><MyTeam /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </ThemeProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
